import { QueryClient } from "@tanstack/react-query";

import { QueryKey } from "@/query/Query";

import { ASSET_INVENTORY_ZONE_QUERY_KEYS } from "./DropZoneDnd.types";

/** Invalidates every document list a cross-zone move can affect (panel sections + asset areas). */
export function invalidateDocumentZoneQueries(queryClient: QueryClient, clientId: string | undefined) {
  void queryClient.invalidateQueries({ queryKey: [QueryKey.DropZoneFiles] });
  if (clientId) {
    void queryClient.invalidateQueries({ queryKey: [QueryKey.ClientDocuments, clientId] });
    void queryClient.invalidateQueries({ queryKey: [QueryKey.ClientSelfDocuments, clientId] });
    for (const assetListQueryKey of Object.values(ASSET_INVENTORY_ZONE_QUERY_KEYS)) {
      void queryClient.invalidateQueries({ queryKey: [assetListQueryKey, clientId] });
    }
  }
}
